import React from "react";
import { MenuItem } from "@mui/material";

import { TextField } from "../../../../components";

const ValueType = React.memo(({ field, state, editState, dispatch }) => {
  const handleFieldChange = (value, name, key) => {
    dispatch({ type: "UPDATE_FIELD", payload: { value, name, key } });
  };
  return (
    <TextField
      size="small"
      value={state?.[field.field_name]?.value_type}
      label={"Select Value Type"}
      disabled={!editState}
      select
      onChange={(e) =>
        handleFieldChange(e.target.value, field.field_name, "value_type")
      }
    >
      <MenuItem disabled value={undefined}>
        Select Value
      </MenuItem>
      <MenuItem value="individual">Individual</MenuItem>
      <MenuItem value="range">Range</MenuItem>
    </TextField>
  );
});

export default ValueType;
